import { useEffect } from "react";
import { useAuth } from "../context/auth";
import { useStepStore } from "../stores/stepStore";
import { useQueryStore } from "../stores/queryStore";
import { useUserMortgageProfileStore } from "../stores/userProfileStore";
import { MortgageStatusEnum } from "../interfaces/mortgageDetailsInterface";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

const AuthLayout = ({ type }: { type: "public" | "private" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { authenticated } = useAuth();
  const step = useStepStore((state) => state.step);
  const setStep = useStepStore((state) => state.setStep);
  const { userMortgageProfile } = useUserMortgageProfileStore();
  const { setQueryReferralCode } = useQueryStore();

  useEffect(() => {
    const decodedUrl = decodeURIComponent(location.search);
    const query = new URLSearchParams(decodedUrl);
    const referralCode = query.get("rc");
    if (referralCode) {
      setQueryReferralCode(referralCode);
    }
  }, [setQueryReferralCode, location.search]);


  useEffect(() => {
    const enforceRouteAccess = () => {
      const restrictedRoutes: {
        "/confirmation": MortgageStatusEnum;
        "/documents": MortgageStatusEnum;
        "/pending-contact": MortgageStatusEnum;
        "/submitted": MortgageStatusEnum;
      } = {
        "/confirmation": MortgageStatusEnum.PendingDocuments,
        "/documents": MortgageStatusEnum.PendingDocuments,
        "/pending-contact": MortgageStatusEnum.PendingContact,
        "/submitted": MortgageStatusEnum.PendingApproval,
      };

      const currentPath = location.pathname as keyof typeof restrictedRoutes;

      if (
        restrictedRoutes[currentPath] &&
        userMortgageProfile?.status !== restrictedRoutes[currentPath]
      ) {
        console.warn(
          `Access denied to ${currentPath} for status: ${userMortgageProfile?.status}`
        );
        setStep(1);
        navigate("/", { replace: true });
      }
    };

    // const enforceStepOrder = () => {
    //   let updated = false;
    //   if (userMortgageProfile?.status === MortgageStatusEnum.Incomplete) {
    //     if (
    //       !(
    //         userMortgageProfile?.firstName &&
    //         userMortgageProfile?.lastName &&
    //         userMortgageProfile?.address &&
    //         userMortgageProfile?.maritalStatus &&
    //         userMortgageProfile?.phoneNumber &&
    //         userMortgageProfile?.dateOfBirth
    //       ) &&
    //       step > 1
    //     ) {
    //       setStep(1);
    //       navigate("/");
    //       updated = true;
    //     } else if (
    //       userMortgageProfile?.firstName &&
    //       userMortgageProfile?.lastName &&
    //       userMortgageProfile?.address &&
    //       userMortgageProfile?.maritalStatus &&
    //       userMortgageProfile?.phoneNumber &&
    //       userMortgageProfile?.dateOfBirth &&
    //       userMortgageProfile?.isFirstTimeHomeBuyer &&
    //       !userMortgageProfile?.incomeSource &&
    //       step > 2
    //     ) {
    //       setStep(2);
    //       navigate("/employment-details");
    //       updated = true;
    //     } else if (
    //       userMortgageProfile?.incomeSource &&
    //       !userMortgageProfile?.coApplicants &&
    //       step > 3
    //     ) {
    //       setStep(3);
    //       navigate("/co-applicants");
    //       updated = true;
    //     } else if (
    //       userMortgageProfile?.coApplicants &&
    //       !userMortgageProfile?.downPaymentSources &&
    //       step > 4
    //     ) {
    //       setStep(4);
    //       navigate("/down-payment");
    //       updated = true;
    //     } else if (
    //       userMortgageProfile?.downPaymentSources &&
    //       !userMortgageProfile?.creditConsents &&
    //       step > 5
    //     ) {
    //       setStep(5);
    //       navigate("/credit-consent");
    //       updated = true;
    //     }

    //     return updated;
    //   }
    //   if (userMortgageProfile?.status === MortgageStatusEnum.PendingDocuments) {
    //     if (step < 7) {
    //       setStep(7);
    //       navigate("/confirmation");
    //     }
    //   }

    //   if (userMortgageProfile?.status === MortgageStatusEnum.PendingApproval) {
    //     if (step < 9) {
    //       setStep(9);
    //       navigate("/submitted");
    //     }
    //   }
    //   if (userMortgageProfile?.status === MortgageStatusEnum.PendingContact) {
    //     if (step < 10) {
    //       setStep(10);
    //       navigate("/pending-contact");
    //     }
    //   }
    // };

    // enforceStepOrder();
    enforceRouteAccess();

  }, [setStep, navigate, userMortgageProfile, location.pathname]);

  if (type === "public") {
    if (authenticated) {
      return <Navigate to={location.state?.from || "/"} replace={true} />;
    }
    return <Outlet />;
  }
  if (type === "private") {
    if (authenticated) {
      return <Outlet />;
    }
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace={true}
      />
    );
  }
  return null;
};

export { AuthLayout };
